import { VpProgressBar } from '@vtmn-play/react/headless'
import { useTranslation } from 'react-i18next'
import './loading.scss'

interface LoadingProps {
  loadingLabel?: string
}

export function Loading({ loadingLabel }: Readonly<LoadingProps>) {
  const { t } = useTranslation()
  const label = loadingLabel ?? t('quick-search.loading')

  return (
    <div className="loading-container" data-testid="loading-container">
      <VpProgressBar variant="circular" aria-label={label} />
      <span>{label}</span>
    </div>
  )
}
